import { render, staticRenderFns } from "./LinkShare.vue?vue&type=template&id=74242f1c&scoped=true&"
import script from "./LinkShare.vue?vue&type=script&lang=js&"
export * from "./LinkShare.vue?vue&type=script&lang=js&"
import style0 from "./LinkShare.vue?vue&type=style&index=0&id=74242f1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74242f1c",
  null
  
)

component.options.__file = "LinkShare.vue"
export default component.exports